import { useTranslation } from 'react-i18next'

import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import { DashboardListRow } from '../../../DashboardBirdview'
import { ICON_COLOR } from '../../../Icon'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import { useRentalPortalOverviewLink } from '../RentalPortalOverview.hooks'

import { OverviewAttentionReason } from './OverviewAttentionReason'
import { OverviewAttentionViewAction } from './OverviewAttentionViewAction'
import { getOverviewAttentionRowLink } from './RentalPortalOverviewAttentionRow.utils'

import * as styles from './RentalPortalOverviewAttentionRow.module.css'

import RentalPortalIcon from '../../../../icons/rental-portal.svg'

function RentalPortalOverviewAttentionRow({ row }) {
  const { t } = useTranslation()

  const link = getOverviewAttentionRowLink(row)

  const {
    handleClickLink: handleClickView,
    handleMouseDownLink: handleMouseDownView,
  } = useRentalPortalOverviewLink({ link })

  return (
    <DashboardListRow
      Before={Avatar}
      Meta={link ? OverviewAttentionViewAction : null}
      Subtitle={OverviewAttentionReason}
      beforeProps={{
        Icon: RentalPortalIcon,
        className: styles.cover,
        iconProps: { color: ICON_COLOR.SecondaryTextColor50 },
        size: AVATAR_HEIGHT_24,
        src: row.avatar_url,
      }}
      metaProps={{
        onMouseDownView: handleMouseDownView,
        onOpenView: handleClickView,
      }}
      subtitleProps={{ row }}
      title={getListingUnitLabel({ listing: row, t })}
    />
  )
}

export default RentalPortalOverviewAttentionRow
